import { render, staticRenderFns } from "./PageLayout.vue?vue&type=template&id=4d7aa0a0&"
import script from "./PageLayout.vue?vue&type=script&lang=ts&"
export * from "./PageLayout.vue?vue&type=script&lang=ts&"
import style0 from "./PageLayout.vue?vue&type=style&index=0&id=4d7aa0a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports